"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_native_svg_1 = __importStar(require("react-native-svg"));
const scale_1 = require("../../utils/scale");
const IconImage = (props) => (React.createElement(react_native_svg_1.default, { width: (0, scale_1.scale)(30), height: (0, scale_1.scale)(30), viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement(react_native_svg_1.Mask, { id: "mask0_6903_7604", maskUnits: "userSpaceOnUse", x: 0, y: 0, width: (0, scale_1.scale)(30), height: (0, scale_1.scale)(30) },
        React.createElement(react_native_svg_1.Rect, { width: (0, scale_1.scale)(30), height: (0, scale_1.scale)(30), fill: "white" })),
    React.createElement(react_native_svg_1.G, { mask: "url(#mask0_6903_7604)" },
        React.createElement(react_native_svg_1.Path, { d: "M8.43753 20.9374H21.6586L17.548 15.4567L14.0384 20.024L11.5384 16.8269L8.43753 20.9374ZM4.375 25.6249V4.375H25.6249V25.6249H4.375ZM6.24997 23.75H23.75V6.24997H6.24997V23.75Z", fill: "#545454" }))));
exports.default = IconImage;
